module.exports = __webpack_public_path__ + "static/media/default-author.4ea6c41b.png";